/* Dansk katalog for locale-no.js (del 1 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'common.save': 'Gem ændringer',
  'common.saving': 'Gemmer...',
  'common.cancel': 'Annuller',
  'common.hoursMinutes': '{h}t {m}m',
  'common.delete': 'Slet',
  'common.confirmTitle': 'Er du sikker?',
  'common.continue': 'Fortsæt',
  'account.view': 'Kontovisning',
  'account.relevant': 'Relevante',
  'account.all': 'Alle',
  'account.favorites': 'Favoritter',
  'account.addFavorite': 'Føj til favoritter',
  'account.removeFavorite': 'Fjern fra favoritter',
  'account.searchHint': 'Søg navn, nummer eller f.eks. 5x',
  'common.working': 'Arbejder...',
  'common.close': 'Luk',
  'common.on': 'Til',
  'common.off': 'Fra',
  'common.active': 'Aktiv',
  'common.yes': 'Ja',
  'common.no': 'Nej',
  'month.short.1': 'Jan',
  'month.short.2': 'Feb',
  'month.short.3': 'Mar',
  'month.short.4': 'Apr',
  'month.short.5': 'Maj',
  'month.short.6': 'Jun',
  'month.short.7': 'Jul',
  'month.short.8': 'Aug',
  'month.short.9': 'Sep',
  'month.short.10': 'Okt',
  'month.short.11': 'Nov',
  'month.short.12': 'Dec',
  'ui.summary.title': 'Opsummering',
  'ui.summary.exVat': 'Sum ekskl. moms',
  'ui.summary.vat': 'Moms',
  'ui.summary.total': 'Total',
  'ui.more': 'Mere',
  'ui.filter': 'Filter',
  'ui.filterReset': 'Nulstil filter',
  'ui.filterChoices': 'Filtervalg',
  'ui.period': 'Periode',
  'ui.from': 'Fra',
  'ui.to': 'Til',
  'ui.fromMonth': 'Fra måned',
  'ui.toMonth': 'Til måned',
  'ui.fromDate': 'Fra dato',
  'ui.toDate': 'Til dato',
  'ui.today': 'I dag',
  'ui.wholeYearTitle': 'Hele {year}',
  'ui.quick.wholeYear': 'Hele året',
  'ui.quick.ytd': 'År til dato',
  'ui.quick.thisTerm': 'Denne termin',
  'ui.quick.lastYear': 'Sidste år',
  'ui.term': 'Termin {n}',
  'ui.amountSearch': 'Søg på beløb',
  'ui.amountFrom': 'Beløb fra',
  'ui.amountTo': 'Beløb til',
  'list.search': 'Søg',
  'list.copy': 'Kopiér',
  'list.copied': 'Kopieret: {text}',
  'list.export': 'Eksportér',
  'list.download': 'Download',
  'list.downloaded': '{label} downloadet',
  'list.nothingToExport': 'Ingen rækker at eksportere',
  'list.downloading': '{label} downloades …',
  'list.upload': 'Upload',
  'list.add': 'Tilføj',
  'list.archiveTitle': 'Flyt til arkiv?',
  'list.archiveConfirm': 'Flyt til arkiv',
  'list.deleteTitle': 'Slet?',
  'list.delete': 'Slet',
  'list.archiveBody': 'Vil du flytte {name} til arkivet? Kunden skjules fra aktive kundelister, men fakturaer, betalinger og historik bevares. Dette kan ikke fortrydes herfra.',
  'list.deleteBody': 'Er du sikker på, at du vil slette {name}? Dette kan ikke fortrydes.',
  'crm.prospect': 'Prospekt',
  'crm.active': 'Aktiv',
  'crm.quoteSent': 'Tilbud sendt',
  'crm.pause': 'På pause',
  'badge.paid': 'Afregnet',
  'badge.active': 'Aktiv',
  'badge.sent': 'Sendt',
  'badge.draft': 'Kladde',
  'badge.created': 'Ikke sendt',
  'badge.overdue': 'Forfalden',
  'badge.credited': 'Krediteret',
  'badge.inactive': 'Passiv',
  'badge.ok': 'Indsendt',
  'badge.no': 'Ikke indsendt',
  'badge.soon': 'Forfalder snart',
  'status.draft': 'Kladde',
  'status.created': 'Ikke sendt',
  'status.sent': 'Sendt',
  'status.paid': 'Betalt',
  'status.overdue': 'Forfalden',
  'status.credited': 'Krediteret',
  'app.loading': 'Indlæser dit regnskab…',
  'app.loadingPersonalFinance': 'Indlæser din privatøkonomi…',
  'app.loadingEmployeePortal': 'Indlæser din medarbejderportal…',
  'project.cost.field': 'Projekt',
  'project.cost.none': 'Ikke på projekt',
  'project.cost.billable': 'Viderefaktureres til kunden',
  'project.cost.pickTitle': 'Vælg projekt',
  'project.cost.search': 'Søg efter projekt eller kunde',
  'project.cost.searchEmpty': 'Ingen projekter passer til søgningen.',
  'project.cost.toProject': 'Til projekt',
  'app.employeePortalVerifyTitle': 'Bekræft din e-mailadresse',
  'app.employeePortalVerifyText': 'Vi har sendt et bekræftelseslink til {{email}}. Det kan tage nogle minutter, før det kommer. Tjek også spam. Åbn linket for at fortsætte.',
  'app.employeePortalVerifyResend': 'Send linket igen',
  'app.employeePortalVerifySent': 'Bekræftelseslinket er sendt igen.',
  'app.employeePortalVerifyAlready': 'E-mailadressen er allerede bekræftet. Genindlæs siden.',
  'app.employeePortalVerifyFailed': 'Kunne ikke sende bekræftelseslink.',
  'app.emailVerifyCheck': 'Jeg har bekræftet',
  'app.emailVerifyConfirmed': 'E-mailadressen er bekræftet.',
  'app.emailVerifyNotConfirmed': 'E-mailadressen er ikke bekræftet endnu. Åbn linket i e-mailen, og prøv igen.',
  'app.emailVerifyCheckFailed': 'Kunne ikke kontrollere e-mailadressen.',
  'app.emailVerifyInitialFailed': 'Kontoen blev oprettet, men bekræftelseslinket kunne ikke sendes. Prøv at sende det igen.',
  'app.placeholder.title': 'Denne side er på vej',
  'app.placeholder.text': 'Vi lægger sidste hånd på detaljerne her. Kig forbi snart!',
  'app.nobusiness.title': 'Hvad vil du starte med?',
  'app.nobusiness.text': 'Du er logget ind, men har ingen virksomhed i Plumme endnu.',
  'app.nobusiness.create': 'Opret virksomhed',
  'app.nobusiness.signOut': 'Log ud',
  'common.signOut': 'Log ud',
  'auth.sub.default': 'Enkel bogføring for små virksomheder',
  'auth.sub.forgot': 'Nulstil din adgangskode',
  'auth.sub.sent': 'Tjek din e-mail',
  'auth.sub.signup': 'Opret konto, og opsæt virksomheden',
  'auth.language': 'Sprog',
  'auth.invite.household': 'Du har fået en invitation til familieøkonomi. Log ind, eller opret en konto med den e-mailadresse, invitationen blev sendt til.',
  'auth.invite.business': 'Du har fået en klientinvitation. Indtast den e-mailadresse, invitationen blev sendt til, så åbner vi invitationen efter login.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'din@epost.no',
  'auth.password': 'Adgangskode',
  'auth.name': 'Navn',
  'auth.namePlaceholder': 'Dit navn',
  'auth.passwordMin': 'Mindst 6 tegn',
  'auth.showPassword': 'Vis adgangskode',
  'auth.hidePassword': 'Skjul adgangskode',
  'auth.remember': 'Husk mig',
  'auth.forgot': 'Glemt adgangskode?',
  'auth.signIn': 'Log ind',
  'auth.signingIn': 'Logger ind...',
  'auth.noAccount': 'Har du ikke en konto?',
  'auth.createAccount': 'Opret konto',
  'auth.creating': 'Opretter...',
  'auth.backToLogin': 'Tilbage til login',
  'auth.forgotCopy': 'Indtast den e-mail, du logger ind med, så sender vi dig et link til at oprette en ny adgangskode.',
  'auth.sendResetLink': 'Send nulstillingslink',
  'auth.sending': 'Sender...',
  'auth.sentCopy': 'Vi har sendt et link til {email}. Følg linket i e-mailen for at oprette en ny adgangskode.',
  'auth.wrongEmail': 'Brugte vi den forkerte e-mail? Prøv igen',
  'auth.error.signIn': 'Login mislykkedes.',
  'auth.error.reset': 'Kunne ikke sende nulstillingslink.',
  'auth.error.signUp': 'Kunne ikke oprette konto.',
  'capture.scan': 'Scan bilag',
  'capture.toInbox': 'Til Indbakke',
  'capture.toPurchase': 'Til Betalt køb',
  'capture.analysisFailed': 'Bilaget blev uploadet, men analysen mislykkedes.',
  'capture.readyInPurchase': 'Bilaget er klar i Betalt køb.',
  'capture.uploadingToInbox': 'Uploader bilaget til Indbakke ...',
  'capture.uploadedToInbox': 'Bilag uploadet til Indbakke.',
  'capture.uploadFailed': 'Kunne ikke uploade bilaget.',
  'capture.analysisTimedOut': 'Bilaget er indsendt. Analysen tager lidt tid og fortsætter i baggrunden.',
  'capture.paymentDialogLoadFailed': 'Kunne ikke indlæse betalingsmulighederne. Prøv igen.',
  'nav.home': 'Hjem',
  'nav.aiBookkeeper': 'AI Bogholder',
  'nav.aiAdvisor': 'AI Rådgiver',
  'nav.newSale': 'Nyt salg',
  'nav.invoices': 'Fakturaliste',
  'nav.otherSales': 'Andet salg',
  'nav.customers': 'Kunder',
  'nav.products': 'Produkter',
  'nav.projects': 'Projekter',
  'nav.subscriptions': 'Aftaler',
  'nav.newPurchase': 'Nyt køb',
  'nav.manualEntry': 'Fri postering',
  'nav.suppliers': 'Leverandører',
  'nav.assets': 'Aktiver',
  'nav.inventory': 'Varelager',
  'nav.inbox': 'Indbakke',
  'nav.incomeStatement': 'Resultatopgørelse',
  'nav.trialBalance': 'Saldobalance',
  'nav.budget': 'Budget',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Årsafslutning',
  'nav.annualAccounts': 'Årsregnskab',
  'nav.payroll': 'Løn',
  'nav.mileageLog': 'Kørebog',
  'nav.vouchers': 'Transaktioner',
  'nav.bank': 'Bank',
  'nav.myPage': 'Min side',
  'nav.activityLog': 'Aktivitetslog',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Indstillinger',
  'navgroup.sales': 'Salg',
  'navgroup.purchases': 'Køb',
  'navgroup.reports': 'Rapporter',
  'navgroup.filings': 'Indberetninger',
  'navgroup.employees': 'Medarbejdere',
  'navgroup.other': 'Andet',
  'navgroup.miscellaneous': 'Øvrigt',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Indstillinger',
  'navhelp.home': 'Din startside – nøgletal, grafer og genveje til at registrere salg og køb.',
  'navhelp.aiBookkeeper': 'SuperPlumma gennemgår bank, bilag, moms og frister og laver forslag. Du kontrollerer og godkender, før noget bogføres.',
  'navhelp.aiAdvisor': 'Økonomisk rådgivning fra SuperPlumma – sundhedsscore, anbefalinger, likviditetsprognose, risiko og skatteoptimering.',
  'navhelp.newSale': 'Lav en ny faktura eller et tilbud til en kunde. Salget bogføres automatisk.',
  'navhelp.invoices': 'Oversigt over alle fakturaer og tilbud – status, forfald og betaling.',
  'navhelp.customers': 'Dit kunderegister. Tilføj og redigér de kunder, du fakturerer.',
  'navhelp.products': 'Varer og ydelser, du sælger, med pris og momssats – klar til brug på fakturaer.',
  'navhelp.projects': 'Registrér timer på projekter og aktiviteter, følg med i, hvad der er gjort, og gør ufakturerede timer til fakturakladder.',
  'navhelp.subscriptions': 'Abonnementer, gentagne fakturaer og kundelister med kontrol over automatiske udsendelser.',
  'navhelp.newPurchase': 'Registrér et køb eller en leverandørfaktura med bilag, leverandør, beløb og konto.',
  'navhelp.manualEntry': 'Bogfør manuelt direkte på konto, når du har brug for fuld kontrol over posteringen.',
  'navhelp.suppliers': 'Dit leverandørregister – navn, org.nr. og kontonummer til udbetalinger.',
  'navhelp.assets': 'Driftsmidler og varige værdier, der afskrives over tid.',
  'navhelp.inventory': 'Vareoptælling og værdien af dit varelager. Dokumentér optællingen, og bogfør ændringen i beholdningen.',
  'navhelp.inbox': 'Bilag, der er kommet ind, men ikke bogført endnu. Træk dem over på den rigtige bogføring.',
  'navhelp.incomeStatement': 'Indtægter minus omkostninger – her ser du, om virksomheden giver overskud.',
  'navhelp.trialBalance': 'Saldo på alle konti – grundlaget for dine regnskabsrapporter.',
  'navhelp.budget': 'Opret et budget, og følg med i, hvordan du ligger i forhold til målene.',
  'navhelp.filings': 'Kontrollér momsgrundlaget for hver periode. Selve meldingen indsendes hos Skatteetaten.',
  'navhelp.taxReturn': 'Udkast til skattemelding baseret på regnskabet – kontrollér tallene, før du indsender hos Skatteetaten.',
  'navhelp.yearEndClosing': 'Trin for trin gennem alt, der skal gøres for at lukke regnskabsåret.',
  'navhelp.annualAccounts': 'Resultat, balance, noter og underskrift. Årsregnskabet indsendes til Regnskapsregisteret uden for Plumme.',
  'navhelp.payroll': 'Kør løn, lav lønsedler, og bogfør lønnen. A-meldingen indsendes uden for Plumme.',
  'navhelp.mileageLog': 'Registrér kørsel i arbejdet, og se kilometer og fradrag for året.',
  'navhelp.vouchers': 'Samlet oversigt over bogførte transaktioner og tilhørende bilag – søg og find igen.',
  'navhelp.bank': 'Upload kontoudtog, og afstem bankkontiene mod regnskabet.',
  'navhelp.myPage': 'Din egen profil og dine indstillinger som bruger.',
  'navhelp.activityLog': 'Fuld historik over, hvad der er gjort i regnskabet, og af hvem.',
  'navhelp.altinn': 'Genvej til indsendelser og post i Altinn.',
  'navhelp.settings': 'Indstillinger for selskabet, regnskabet og appen.',
  'navhelp.fallback': 'Åbn {label}.',
  'route.home': 'Hjem',
  'route.newSale': 'Nyt salg',
  'route.newSaleliste': 'Fakturaliste',
  'route.customers': 'Kunder',
  'route.products': 'Produkter',
  'route.projects': 'Projekter',
  'route.aiBookkeeper': 'AI Bogholder',
  'route.aiAdvisor': 'AI Rådgiver',
  'route.newPurchase': 'Betalt køb',
  'route.manualEntry': 'Fri postering',
  'route.vouchers': 'Transaktioner',
  'route.suppliers': 'Leverandører',
  'route.assets': 'Aktiver',
  'route.filings': 'Indsendelser',
  'route.inbox': 'Indbakke',
  'route.documentation': 'Dokumentation',
  'route.mileageLog': 'Kørebog',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Indstillinger',
  'route.otherSales': 'Andet salg',
  'route.subscriptions': 'Aftaler',
  'route.incomeStatement': 'Resultatopgørelse',
  'route.trialBalance': 'Saldobalance',
  'route.budget': 'Budget',
  'route.payroll': 'Løn',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Årsafslutning',
  'route.annualAccounts': 'Årsregnskab',
  'route.myPage': 'Min side',
  'route.employeePortal': 'Medarbejderportal',
  'route.activityLog': 'Aktivitetslog',
  'route.personalFinance': 'Privatøkonomi',
  'shell.openMenu': 'Åbn menu',
  'shell.closeMenu': 'Luk menu',
  'shell.collapseMenu': 'Skjul menu',
  'shell.showLabels': 'Vis menutekst',
  'shell.hideLabels': 'Skjul menutekst',
  'shell.designSystem': 'Designsystem ↗',
  'shell.customizeMenu': 'Tilpas menu',
  'shell.customizeHelpTitle': 'Tilpas menu',
  'shell.customizeHelp': 'Vælg, hvilke sider der skal vises i sidemenuen. Skjul dem, du ikke bruger, for at holde menuen ryddelig.',
  'shell.customizeTitle': 'Tilpas sidemenuen',
  'shell.customizeVisible': '{visible} af {total} synlige',
  'shell.customizeLead': 'Slå sider fra, som du ikke bruger, så skjules de i sidemenuen. Du kan slå dem til igen når som helst.',
  'shell.customizeAllPages': 'Alle sider',
  'shell.customizeAiMode': 'AI-tilstand',
  'shell.customizeAlwaysOn': 'Altid til',
  'shell.customizeDone': 'Færdig',
  'shell.camCapture': 'Tag billede af bilag',
  'shell.camHelp': 'Tag et billede af et bilag med kameraet, og upload det direkte til Indbakken eller som et nyt køb.',
  'shell.moreOptions': 'Flere valg',
  'shell.search': 'Søg',
  'shell.searchAll': 'Søg i alt',
  'shell.searchHelp': 'Søg i den aktive virksomhed — kunder, fakturaer, produkter, bilag, projekter, sider og hjælp. Tryk for at åbne søgningen (genvej: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Søg i alt — fakturaer, kunder, bilag…',
  'shell.searchEnterHint': 'for at se alle resultater',
  'shell.companyHelpTitle': 'Vælg virksomhed eller arbejdsgiver',
  'shell.companyHelp': 'Skift mellem de regnskaber, du fører, og de arbejdsgivere, du er ansat hos. Alt, hvad du ser i appen, gælder den valgte virksomhed.',
  'shell.yearHelpTitle': 'Regnskabsår',
  'shell.yearHelp': 'Vælg, hvilket regnskabsår du arbejder med. Alle tal og indsendelser gælder det valgte år.',
  'shell.theme.helpTitle': 'Lyst / mørkt tema',
  'shell.theme.help': 'Skift mellem lyst og mørkt udseende i hele appen. Valget huskes til næste gang.',
  'shell.theme.toLight': 'Skift til lyst tema',
  'shell.theme.toDark': 'Skift til mørkt tema',
  'shell.theme.light': 'Lyst tema',
  'shell.theme.dark': 'Mørkt tema',
  'shell.bg.label': 'Baggrundsfarve',
  'shell.bg.title': 'Baggrundsfarve for denne side',
  'shell.bg.help': 'Vælg baggrundsfarve for netop denne side. Farven gemmes pr. side.',
  'shell.bg.menuTitle': 'Baggrundsfarve · denne side',
  'shell.bg.default': 'Blomme',
  'shell.bg.mint': 'Mint',
  'shell.bg.varm': 'Varm',
  'shell.bg.sky': 'Blå',
  'shell.bg.rose': 'Rosa',
  'shell.bg.skog': 'Skov',
  'skin.title': 'Udseende',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Klassisk',
  'skin.klassiskSub': 'Nøgtern',
  'shell.client.employers': 'Dine arbejdsgivere',
  'shell.client.employer': 'Arbejdsgiver',
  'shell.client.employee': 'Medarbejder',
  'shell.client.private': 'Privat',
  'shell.client.firm': 'Bogholderibureau',
  'shell.client.firmSub': 'Klientoversigt og afstemning',
  'rf.firm': 'Bogholderibureau',
  'rf.role.owner': 'Ejer',
  'rf.role.admin': 'Administrator',
  'rf.role.employee': 'Medarbejder',
  'rf.group.firm': 'Bogholder',
  'rf.group.team': 'Teamchat',
  'rf.group.other': 'Øvrigt',
  'rf.nav.clients': 'Klientoversigt',
  'rf.nav.reconciliation': 'Afstemning',
  'rf.nav.control': 'Kontrol',
  'rf.nav.teamchat': 'Teamchat',
  'rf.nav.members': 'Medarbejdere',
  'rf.nav.clientList': 'Klienter',
  'rf.client.pageBody': 'Knyt bureauet til dets klienter, og tildel medarbejdere til opgaverne.',
  'rf.client.addTitle': 'Knyt til en klient',
  'rf.client.addBody': 'Klienten skal have en Plumme-konto for sin virksomhed. Bureauet får først adgang, når klienten har accepteret.',
  'rf.client.billedTo': 'Hvem betaler',
  'rf.client.billedToClient': 'Klienten betaler selv',
  'rf.client.billedToFirm': 'Bureauet betaler',
  'rf.client.request': 'Send anmodning',
  'rf.client.requesting': 'Sender …',
  'rf.client.requested': 'Anmodningen er sendt til klienten',
  'rf.avst.noClient': 'Vælg en klient først',
  'rf.avst.allClients': 'Alle klienter',
  'rf.avst.thisClient': 'Denne klient',
  'rf.avst.noClientBody': 'Afstemning gælder én klient ad gangen. Åbn en klient fra klientoversigten, så følger afstemningsmappen med.',
  'rf.client.requestedMailFailed': 'Anmodningen er sendt, men notifikationen på e-mail kunne ikke sendes. Klienten ser den ved næste login.',
  'rf.client.requestedNoRecipient': 'Anmodningen er sendt, men virksomheden har ingen ejer eller administrator at give besked. Kontakt selv klienten.',
  'rf.client.noneTitle': 'Ingen klienter endnu',
  'rf.client.noneBody': 'Knyt bureauet til en klient med organisationsnummeret. Klienten skal godkende, før I får adgang.',
  'rf.client.pendingBody': 'Klienten skal acceptere anmodningen i sin egen Plumme-konto. Ingen i bureauet har adgang inden da.',
  'rf.client.assignWho': 'Tildel opgaven',
  'rf.client.assignPick': 'Vælg medarbejder',
  'rf.client.assignRole': 'Rolle på opgaven',
  'rf.client.assign': 'Tildel',
  'rf.client.assigned': 'Medarbejderen er tildelt klienten',
  'rf.client.end': 'Afslut opgaven',
  'rf.client.ended': 'Opgaven er afsluttet',
  'rf.client.endConfirm': 'Afslut opgaven for {name}? Den adgang, bureauet har givet medarbejderne, trækkes tilbage samtidig.',
  'fe.title': 'Et bogholderibureau anmoder om adgang',
  'fe.theFirm': 'Bureauet',
  'fe.body': 'Accepterer du, får de medarbejdere, bureauet tildeler opgaven, adgang til dit regnskab. Du kan afslutte samarbejdet når som helst.',
  'fe.billedToFirm': 'Bureauet betaler abonnementet',
  'fe.billedToClient': 'Du betaler selv abonnementet',
  'fe.accept': 'Giv adgang',
  'fe.accepting': 'Accepterer …',
  'fe.accepted': '{firm} har nu adgang til regnskabet.',
  'fe.decline': 'Afvis',
  'fe.declined': 'Anmodningen er afvist.',
  'fi.title': 'Du er inviteret som medarbejder',
  'fi.theFirm': 'bureauet',
  'fi.body': 'Invitationen giver dig adgang til selve bureauet. Adgang til den enkelte klient får du først, når bureauet sætter dig på en opgave.',
  'fi.verifyFirst': 'Bekræft din e-mailadresse først. Vi har sendt et nyt bekræftelseslink.',
  'fi.accept': 'Bliv medlem',
  'fi.accepting': 'Bliver medlem …',
  'fi.accepted': 'Du er nu medarbejder i {firm}.',
  'fi.acceptFailed': 'Kunne ikke acceptere invitationen.',
});

window.PlummeI18n.register("da", {"nav.kjopsoversikt": "Købsliste", "route.kjopsoversikt": "Købsliste"});
